import CIRCLE from './images/Circle.svg'
import CIRCLE_CHECKED from './images/CircleChecked.svg'

type BaseCheckBoxProps = {
  value: boolean;
  onChange?: (checked: boolean) => void;
}

const BaseCheckBox = (props: BaseCheckBoxProps) => {
  const handleClick = () => {
    if (props.onChange) {
      props.onChange(!props.value);
    }
  };

  return <>
    <img 
      style={{ display: 'block', width: '16px', height: '16px', marginRight: '4px', cursor: 'pointer' }} 
      src={ props.value ? CIRCLE_CHECKED : CIRCLE }
      onClick={handleClick}
    ></img>
  </>
}

export default BaseCheckBox